const Card = {
  parts: ['card', 'header', 'body', 'footer'],
  baseStyle: ({ isOnlyCard }) => ({
    card: {
      display: 'flex',
      flexDirection: 'column',
      padding: isOnlyCard ? '3rem' : '0',
      background: 'white',
      overflow: 'hidden',
    },
    body: {
      alignItems: 'center',
      padding: '1rem 3rem',
      gap: 6,
    },
    header: {
      alignItems: 'center',
      padding: '3rem 3rem 1rem',
      gap: 6,
      borderBottom: '1px solid',
      borderBottomColor: 'gray.200',
    },
    footer: {
      gap: 6,
      alignItems: 'center',
      padding: '1rem 3rem 3rem',
      marginTop: '-1px',
      borderTop: '1px solid',
      borderTopColor: 'gray.200',
    },
  }),
  sizes: {
    sm: ({ isOnlyCard }) => ({
      card: {
        padding: isOnlyCard ? '2rem' : '0',
      },
      body: {
        padding: '2rem',
      },
      header: {
        padding: '2rem',
      },
      footer: {
        padding: '2rem',
      },
    }),
  },
  variants: {
    rounded: {
      card: {
        borderRadius: 'xl',
        boxShadow: 'md',
      },
    },
  },
  defaultProps: {
    variant: 'rounded',
  },
};

export default Card;
